import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {
    Box,
    Button,
    Stack,
    Center,
    Text,
    Image
} from '@salesforce/retail-react-app/app/components/shared/ui'
import Link from '@salesforce/retail-react-app/app/components/link'
import {
    descriptionMessageStyle,
    emptyCartTitle,
    iconStyle,
    recommendedProductStyle,
    shoppingButtonStyle,
    signinButtonStyle
} from './index.style'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'
import RecommendedProducts from '../../../../components/recommended-products'
import {pxToRem} from '../../../../utills/pxToRem'

const EmptyCart = ({isRegistered, previousSearchParams}) => {
    return (
        <Box
            data-testid="sf-cart-empty"
            flex="1"
            paddingTop={[pxToRem(20), pxToRem(20), pxToRem(40), pxToRem(40)]}
            paddingLeft={[pxToRem(11), pxToRem(11), pxToRem(45), pxToRem(45)]}
            paddingRight={[pxToRem(11), pxToRem(11), '0px', '0px']}
        >
            <Center>
                <Stack marginTop="0px !important">
                    <Box align="center">
                        <Image
                            sx={iconStyle}
                            src={getAssetUrl('static/img/cart/emptyCart-icon.svg')}
                        />
                    </Box>
                    <Stack marginTop="0px !important">
                        <Stack marginTop="0px !important">
                            <Text sx={emptyCartTitle}>
                                <FormattedMessage
                                    defaultMessage="Your cart is empty!"
                                    id="empty_cart.description.empty_cart!"
                                />
                            </Text>

                            <Text sx={descriptionMessageStyle}>
                                {isRegistered ? (
                                    <FormattedMessage
                                        defaultMessage="Nothing here yet-but that just means more room for boots, hats, and everything in between."
                                        id="empty_cart.message.start_shopping"
                                    />
                                ) : (
                                    <FormattedMessage
                                        defaultMessage="Nothing here yet-but that just means more room for boots, hats, and everything in between."
                                        id="empty_cart.message.sign_in_or_start_shopping"
                                    />
                                )}
                            </Text>
                        </Stack>
                        <Stack marginTop="0px !important">
                            <Box
                                display={['block', 'block', 'flex', 'flex']}
                                marginTop={[pxToRem(20), pxToRem(20), pxToRem(25), pxToRem(25)]}
                                justifyContent="center"
                            >
                                <Button
                                    as={Link}
                                    href={'/'}
                                    sx={isRegistered ? signinButtonStyle : shoppingButtonStyle}
                                >
                                    <FormattedMessage
                                        defaultMessage="Start Shopping >>"
                                        id="empty_cart.link.start_shopping"
                                    />
                                </Button>
                                {!isRegistered && (
                                    <Button
                                        mt={[pxToRem(20), pxToRem(20), '0', '0']}
                                        ml={['0', '0', pxToRem(20), pxToRem(20)]}
                                        as={Link}
                                        href="/login"
                                        sx={signinButtonStyle}
                                    >
                                        <FormattedMessage
                                            defaultMessage="Sign In >>"
                                            id="empty_cart.link.sign_in>>"
                                        />
                                    </Button>
                                )}
                            </Box>
                        </Stack>
                    </Stack>
                </Stack>
            </Center>
            <Box sx={recommendedProductStyle}>
                <RecommendedProducts
                    title="Recommended for you"
                    recommender="best-sellers-null-results"
                    previousSearchParams={previousSearchParams}
                    showQuickView={true}
                />
            </Box>
        </Box>
    )
}
EmptyCart.propTypes = {isRegistered: PropTypes.bool, previousSearchParams: PropTypes.string}

export default EmptyCart
